import { ContactShadows } from '@react-three/drei'
import { Physics } from '@react-three/rapier'
import { useControls } from 'leva'
import { LinearToneMapping, PCFShadowMap } from 'three'

import { Canvas, Helpers } from '@components/helpers'

import { CameraRig } from './CameraRig'
import { World } from './World'

export function Experience() {
  const physicsControls = useControls(
    'physics',
    { debug: false, paused: false },
    { order: 1, collapsed: true },
  )

  return (
    <Canvas
      eventPrefix="client"
      shadows={{ type: PCFShadowMap }}
      gl={{ toneMapping: LinearToneMapping }}
      camera={{
        fov: 45,
        near: 0.1,
        far: 100,
        position: [0, 1, 1],
      }}
    >
      <CameraRig />

      <ContactShadows opacity={0.5} blur={0.5} scale={20} frames={1000} resolution={1024} />

      <Physics {...physicsControls}>
        <World />
        <Helpers />
      </Physics>
    </Canvas>
  )
}
